import { render, staticRenderFns } from "./SelectedDistributor.vue?vue&type=template&id=c87d5dbe&scoped=true&"
import script from "./SelectedDistributor.vue?vue&type=script&lang=js&"
export * from "./SelectedDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87d5dbe",
  null
  
)

export default component.exports